import { render } from "./ChangePassword.vue?vue&type=template&id=5ef0fa3d&scoped=true&ts=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=5ef0fa3d&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef0fa3d"]])

export default __exports__